export interface IPage {
  pageId?: number;
  tutorialId?: number;
  pageNumber?: number;
  title?: string;
  description?: string;
  type?: string;
  contents?: [] | string;
  missions?: [] | string;
}

export class Page implements IPage {
  pageId?: number;
  tutorialId?: number;
  pageNumber?: number;
  title?: string;
  description?: string;
  type?: string;
  contents?: [];
  missions?: [];

  constructor(page: IPage = {}) {
    this.pageId = page.pageId;
    this.tutorialId = page.tutorialId;
    this.pageNumber = page.pageNumber;
    this.title = page.title;
    this.description = page.description;
    this.type = page.type;

    this.contents = JSON.parse('' + page.contents);
    this.missions = JSON.parse('' + page.missions);
  }
}
